import { FormData, FormConfig } from '../types';

// Helper function to get all field names from a form config
const getAllFieldNames = (config: FormConfig): string[] => {
  const fields: string[] = [];
  
  config.forEach(section => {
    if (section.fields) {
      section.fields.forEach(field => {
        fields.push(field.name);
      });
    }
  });
  
  return fields;
};

// Get URL parameters and convert to FormData
export const getFormDataFromParams = (config: FormConfig): Partial<FormData> => {
  const params = new URLSearchParams(window.location.search);
  const formData: Partial<FormData> = {
    photos: {},
    signatures: {}
  };
  
  // Get all field names from the config
  const fieldNames = getAllFieldNames(config);
  
  // Dynamically map URL parameters to form fields
  fieldNames.forEach(fieldName => {
    if (params.has(fieldName)) {
      const value = params.get(fieldName);
      if (value !== null) {
        (formData as any)[fieldName] = value;
      }
    }
  });
  
  return formData;
};

// Generate URL with query parameters based on form data
export const generateShareableUrl = (formType: string, formData: FormData, config: FormConfig): string => {
  const baseUrl = window.location.origin;
  const params = new URLSearchParams();
  
  // Get all field names from the config
  const fieldNames = getAllFieldNames(config);
  
  // Dynamically add form data to URL parameters, excluding date and time fields
  fieldNames.forEach(fieldName => {
    const value = (formData as any)[fieldName];
    // Find the field config to check its type
    if (value && typeof value === 'string') {
      params.append(fieldName, value);
    }
  });
  
  return `${baseUrl}/${formType}?${params.toString()}`;
};

// Get current date formatted as YYYY-MM-DD
export const getCurrentDate = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

// Get current time formatted as HH:MM
export const getCurrentTime = (): string => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}`;
};